import { SPORTS_WITH_STAGE_ID } from "../constants";

export function getMatchIdOrStageId(match) {
    if (SPORTS_WITH_STAGE_ID.includes(match.sportRef || match.sportId)) {
        return match.round;
    } else {
        return match.id;
    }
}
